import(/* webpackMode: "eager" */ "D:\\b\\baczonedz\\src\\app\\global-error.tsx");
